import React from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

function Modal(props) {
  const { open, onClose, children } = props;
  const { Modal: ModalMui } = useUiContext();

  return (
    <ModalMui open={open} onClose={onClose}>
      {children}
    </ModalMui>
  );
}

Modal.defaultProps = {
  className: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
};

export default Modal;
